export default "__VITE_ASSET__84917faa__"